<div class="modal-header">
  <h4 class="modal-title">Debrief Recipient and Report Notification</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="onDismiss()" ></button>
</div>
<div class="modal-body">
  <table class="table table-striped table-sm">
    <tr>
      <th>Name</th>
      <th>Proxy Report</th>
    </tr>
    @for (user of filteredUsers | quickSearch: _search; track user) {
      <tr>
        <td>{{user.name}}</td>
        <td class="text-center">
          <div class="form-check">
            <label class="form-check-label">
              <input class="form-check-input" type="checkbox" [(ngModel)]="user.proxy">
            </label>
          </div>
        </td>
      </tr>
    }
  </table>
  @if (!filteredUsers?.length) {
    <i>No users available.</i>
  }
</div>
<div class="modal-footer">
  <div class="col">
    <span class="pull-right">
      <button type="button" class="btn btn-primary" (click)="onClose()"><span class="fa fa-plus"></span> Submit</button>
      <button type="button" class="btn btn-cancel" (click)="onDismiss()"><span class="fa fa-ban"></span> Cancel</button>
    </span>
  </div>
</div>
